"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@qc-modules/styles");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _container = require("./container");

var _excluded = ["animateGlyph"],
    _excluded2 = ["animateGlyph", "height", "width"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var GlyphContainer = (0, _styledComponents["default"])(function (_ref) {
  var animateGlyph = _ref.animateGlyph,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, props);
}).withConfig({
  displayName: "glyph__GlyphContainer",
  componentId: "sc-1hu0a6q-0"
})(["", ";", ";"], (0, _styles.defaultTransition)("transform"), function (_ref2) {
  var animateGlyph = _ref2.animateGlyph;
  return animateGlyph ? (0, _styledComponents.css)(["", ":hover &{transform:translate3d(5px,0,0);}", ":hover &{transform:translate3d(5px,0,0);}"], _container.ButtonContainer, _container.LinkContainer) : null;
});
var propTypes = {
  /** A boolean to represent whether the glyph should be animated or not */
  animateGlyph: _propTypes.bool,

  /** Determines the height of the button glyph */
  height: _propTypes.number,

  /** Determines the width of the button glyph */
  width: _propTypes.number
};

var ButtonGlyph = function ButtonGlyph(_ref3) {
  var _ref3$animateGlyph = _ref3.animateGlyph,
      animateGlyph = _ref3$animateGlyph === void 0 ? true : _ref3$animateGlyph,
      _ref3$height = _ref3.height,
      height = _ref3$height === void 0 ? 24 : _ref3$height,
      _ref3$width = _ref3.width,
      width = _ref3$width === void 0 ? 24 : _ref3$width,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded2);

  return /*#__PURE__*/_react["default"].createElement(GlyphContainer, _extends({
    animateGlyph: animateGlyph,
    display: "inline-block",
    flex: "0 0 auto",
    height: height,
    lineHeight: "0px",
    width: width
  }, props));
};

ButtonGlyph.propTypes = propTypes;
ButtonGlyph.displayName = "Modules.ButtonGlyph";
var _default = ButtonGlyph;
exports["default"] = _default;